import { NextRouter } from 'next/router';

export const removeQueryParamsFromRouter = (
  router: NextRouter,
  removeList: string[] = []
): void => {
  if (removeList.length > 0) {
    removeList.forEach((param) => delete router.query[param]);
  } else {
    Object.keys(router.query).forEach((param) => delete router.query[param]);
  }
  router.replace(
    {
      pathname: router.asPath.split('?')[0],
      query: router.query
    },
    undefined,
    { shallow: true }
  );
};
